{
  "title": "Gruppen",
  "subtitle": "Aus dem Kundenverzeichnis gespiegelt. Legen Sie Feldauffüllungen für leere Attribute fest, eine Priorität bei Mehrfachmitgliedschaft und optional eine Signatur für Mitglieder ohne Operatorregel.",
  "searchPlaceholder": "Gruppen suchen",
  "colGroup": "Gruppe",
  "colMembers": "Mitglieder",
  "colPriority": "Priorität",
  "colOverrides": "Überschreibungen",
  "colSignature": "Signatur",
  "emptySearch": "Keine Gruppe entspricht dieser Suche.",
  "emptyNone": "Noch keine Gruppen synchronisiert. Verbinden Sie ein Verzeichnis unter Übersicht oder Onboarding.",
  "priority": "Priorität",
  "signatureTemplate": "Gruppensignatur",
  "noSignature": "Keine (durchfallen)",
  "overrides": "Attributüberschreibungen",
  "save": "Gruppe speichern",
  "saved": "Gruppe gespeichert.",
  "saveError": "Gruppe konnte nicht gespeichert werden.",
  "none": "Keine",
  "count": "{{count}}",
  "groupFallback": "Gruppe",
  "fieldsCount": "{{count}} Feld",
  "fieldsCount_other": "{{count}} Felder",
  "signatureSet": "Gesetzt",
  "overridePriorityTitle": "Überschreibungspriorität",
  "overridePriorityHint": "Wenn eine Person in mehreren Gruppen ist, die dasselbe leere Feld füllen, gewinnt die höhere Priorität.",
  "savePriority": "Priorität speichern",
  "prioritySaved": "Priorität gespeichert.",
  "groupSignatureTitle": "Gruppensignatur",
  "groupSignatureHint": "Wird verwendet, wenn keine Operatorregel passt und die Person keine individuelle Signatur hat. Verliert gegen Regeln; schlägt den Mandanten-Standard.",
  "publishTemplateFirst": "Veröffentlichen Sie eine Vorlage, bevor Sie eine Gruppensignatur zuweisen.",
  "newMessages": "Neue Nachrichten",
  "replies": "Antworten",
  "sameAsNew": "Wie neu",
  "saveSignature": "Signatur speichern",
  "signatureSaved": "Gruppensignatur gespeichert.",
  "signatureCleared": "Gruppensignatur gelöscht.",
  "fieldFillsTitle": "Feldauffüllungen",
  "fieldFillsSaved": "Feldauffüllungen gespeichert.",
  "membersTitle": "Mitglieder",
  "membersHint": "Die Mitgliedschaft wird aus dem Verzeichnis synchronisiert, einschließlich verschachtelter Gruppen.",
  "noMembers": "Noch keine Mitglieder synchronisiert.",
  "viaNestedGroup": "über verschachtelte Gruppe",
  "couldNotSave": "Speichern fehlgeschlagen."
}
